import { Form } from 'antd';
import { RevxRadio } from 'components';
import { RevxRadioProps } from 'components/RevxRadio';
import { uniqBy } from 'lodash-es';
import { Fragment, useCallback } from 'react';
import { ConfigSvcProps } from '..';
import { useSpecialSpecParameterList } from '../hook/useSpecialSpecParameterList';
import { useSvcDisabled } from '../hook/useSvcDisabled';

interface CommonJobSvcSpecProps extends ConfigSvcProps {
  customerParameterLabels?: string[];
}

const CommonJobSvcSpec = (props: CommonJobSvcSpecProps) => {
  const { id, jobOptionSvc, customerParameterLabels } = props;

  const svcDisabled = useSvcDisabled(props);

  const specialList = useSpecialSpecParameterList();

  const checkParameter = useCallback(
    (parameter: string) => {
      const findSpeciaParameter = specialList.find(
        (item) => parameter === item.description
      );
      if (findSpeciaParameter) {
        return findSpeciaParameter.node;
      } else {
        return (
          <>
            <span>{parameter}</span>
          </>
        );
      }
    },
    [specialList]
  );

  const typeRadioProps = (label: string): RevxRadioProps => {
    return {
      disabled: svcDisabled,
      outSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        wrap: 'wrap',
        className: 'jobconfig-jobOption-content-outSideOption-default',
        style: {
          paddingBottom: 0,
        },
      },
      inSideRevxLayoutProps: {
        align: 'top',
        justify: 'left',
        className: 'jobconfig-jobOption-content-inSideOption-default',
        style: {
          marginRight: 31,
        },
      },
      options:
        uniqBy(
          jobOptionSvc.specs.map((spec) => {
            return {
              value:
                spec.parameters.find((param) => param.label === label)
                  ?.parameter || '',
              children: (
                <>
                  {checkParameter(
                    spec.parameters.find((param) => param.label === label)
                      ?.parameter || ''
                  )}
                </>
              ),
            };
          }),
          'value'
        ) || [],
    };
  };

  return (
    <>
      {Boolean(jobOptionSvc?.specs?.length) &&
        (customerParameterLabels || jobOptionSvc?.parameterLabels)?.map(
          (label, idx) => (
            <Fragment key={`${label}${idx}spec`}>
              <div
              // style={{ margin: '0 0 10px 0' }}
              >
                <div
                  className="jobconfig-jobOption-content-label"
                  style={{ margin: '0px 0 8px 0' }}
                >
                  {label}
                </div>
                <Form.Item name={[id, 'spec', label]} noStyle>
                  <RevxRadio {...typeRadioProps(label)} />
                </Form.Item>
              </div>
            </Fragment>
          )
        )}
    </>
  );
};

export default CommonJobSvcSpec;
